import VueErrorHandler from "./vue-error-handler";
export default Vue => {
  VueErrorHandler(Vue);
};